<template>
  <div
    id="customer-flyout"
    style="min-height:calc(100vh - 50px) !important;padding-bottom:30px"
    class="address-flyout"
    :class="{'d-block':show_customer_address_details,'d-none':!show_customer_address_details}"
  >
    <div class="heading border-bottom">
      <b-row class="px-3" style="padding-top:16px;padding-bottom:16px;">
        <b-col>
          <h5 class="mb-0 text-left">
            Edit Customer Address
            <span class="float-right pr-2">
              <i class="la la-close cursor_pointer" @click="toggleCustomerAddressDetails()"></i>
            </span>
          </h5>
        </b-col>
      </b-row>
    </div>

    <b-row class="pl-4 pr-4">
      <b-col>
        <b-tabs class="customer_view_tab mt-2">
          <b-tab
            title="Billing Address"
            active
            class="pl-0 pt-2 pb-2 pr-2"
            v-if="field.is_billing==1"
          >
            <b-form class="mt-3">
              <b-dropdown
                size="xs"
                dropdown
                variant="primary"
                class="mb-3"
                right
                no-caret
                text="Change Address"
              >
                <b-dropdown-form class="address_view">
                  <b-dropdown-item
                    class="d-flex py-2 border-bottom custom-border-color cursor_pointer"
                    v-for="(list,index) in address"
                    :key="list.cus_addr_id"
                    @click="changebilladdress(index)"
                  >
                    <div class="d-flex">
                      <span>
                        <i class="la la-map-marker" />
                      </span>
                      <div class="px-2 mt-0 pt-0 w-100">
                        <p class="cus-view-addr mb-0">{{list.addr_line_1}}</p>
                        <p class="cus-view-addr mb-0">{{list.addr_line_2}}</p>
                        <p class="cus-view-addr mb-0">{{list.city}}</p>
                        <p
                          class="cus-view-addr mb-0"
                        >{{getDetails($AppDetails.state_details,list.state,'state_name')}}-{{list.pincode}}</p>

                        <p
                          class="cus-view-addr mb-0"
                        >{{getDetails($AppDetails.country_details,list.country,'country_name')}}</p>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown-form>
              </b-dropdown>
              <b-form-group label="Address Line 1" label-for="bill_addr_line_1">
                <b-form-input
                  type="text"
                  size="sm"
                  v-model.trim="field.bill_sal_addr_line_1"
                  name="Billing address line 1"
                  v-validate="'max:200'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Billing address line 1')"
                >{{ errors.first('Billing address line 1') }}</p>
              </b-form-group>
              <b-form-group label="Address Line 2" label-for="bill_sal_addr_line_2">
                <b-form-input
                  type="text"
                  size="sm"
                  v-model.trim="field.bill_sal_addr_line_2"
                  name="Billing address line 2"
                  v-validate="'max:200'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Billing address line 2')"
                >{{ errors.first('Billing address line 2') }}</p>
              </b-form-group>
              <b-form-group label="State" label-for="bill_sal_state">
                <v-select
                  :clearable="false"
                  name="Billing state"
                  id="search-select"
                  v-model.trim="field.bill_sal_state"
                  size="sm"
                  index="state_id"
                  label="state_name"
                  :options="$AppDetails.state_list"
                />
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Billing state')"
                >{{ errors.first('Billing state') }}</p>
              </b-form-group>
              <b-form-group label="City" label-for="bill_sal_city">
                <b-form-input
                  type="text"
                  size="sm"
                  name="Billing city"
                  v-model.trim="field.bill_sal_city"
                  v-validate="'max:200'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Billing city')"
                >{{ errors.first('Billing city') }}</p>
              </b-form-group>
              <b-form-group label="Country" label-for="bill_sal_country">
                <v-select
                  :clearable="false"
                  name="Billing country"
                  id="search-select"
                  v-model.trim="field.bill_sal_country"
                  size="sm"
                  index="country_id"
                  label="country_name"
                  :options="$AppDetails.country_list"
                />
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Billing country')"
                >{{ errors.first('Billing country') }}</p>
              </b-form-group>
              <b-form-group label="Pincode" style="width:150px" label-for="bill_sal_pincode">
                <b-form-input
                  type="text"
                  size="sm"
                  label-for="bill_sal_pincode"
                  name="Billing pincode"
                  v-model.trim="field.bill_sal_pincode"
                  v-validate="'max:10'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Billing pincode')"
                >{{ errors.first('Billing pincode') }}</p>
              </b-form-group>
            </b-form>
          </b-tab>
          <b-tab title="Shipping Address" class="pl-1 pt-3 pb-2 pr-2" v-if="field.is_shipping==1">
            <b-form>
              <b-dropdown
                size="xs"
                dropdown
                variant="primary"
                class="mb-3"
                right
                no-caret
                text="Change Address"
              >
                <b-dropdown-form class="address_view">
                  <b-dropdown-item
                    class="d-flex py-2 border-bottom custom-border-color cursor_pointer"
                    v-for="(list,index) in address"
                    :key="list.cus_addr_id"
                    @click="changeshipaddress(index)"
                  >
                    <div class="d-flex">
                      <span>
                        <i class="la la-map-marker" />
                      </span>
                      <div class="px-2 mt-0 pt-0 w-100">
                        <p class="cus-view-addr mb-0">{{list.addr_line_1}}</p>
                        <p class="cus-view-addr mb-0">{{list.addr_line_2}}</p>
                        <p class="cus-view-addr mb-0">{{list.city}}</p>
                        <p
                          class="cus-view-addr mb-0"
                        >{{getDetails($AppDetails.state_details,list.state,'state_name')}}-{{list.pincode}}</p>
                        <p
                          class="cus-view-addr mb-0"
                        >{{getDetails($AppDetails.country_details,list.country,'country_name')}}</p>
                      </div>
                    </div>
                  </b-dropdown-item>
                </b-dropdown-form>
              </b-dropdown>
              <p
                class="mb-4 mt-0 pt-0 text-link fw-semi-bold"
                @click="copyAddress()"
                v-if="field.is_billing==1"
              >
                <i class="la la-copy la-lg mr-2"></i>
                <span class="btn-link">Shipping same as Billing Address</span>
              </p>
              <b-form-group label="Address Line 1" label-for="ship_sal_addr_line_1">
                <b-form-input
                  type="text"
                  size="sm"
                  name="Shipping address line 1"
                  v-model.trim="field.ship_sal_addr_line_1"
                  v-validate="'max:200'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Shipping address line 1')"
                >{{ errors.first('Shipping address line 1') }}</p>
              </b-form-group>
              <b-form-group label="Address Line 2" label-for="ship_sal_addr_line_2">
                <b-form-input
                  type="text"
                  size="sm"
                  name="Shipping address line 2"
                  v-model.trim="field.ship_sal_addr_line_2"
                  v-validate="'max:200'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Shipping address line 2')"
                >{{ errors.first('Shipping address line 2') }}</p>
              </b-form-group>
              <b-form-group label="State" label-for="ship_sal_state">
                <v-select
                  :clearable="false"
                  name="Shipping state"
                  id="search-select"
                  v-model.trim="field.ship_sal_state"
                  size="sm"
                  index="state_id"
                  label="state_name"
                  :options="$AppDetails.state_list"
                />
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Shipping state')"
                >{{ errors.first('Shipping state') }}</p>
              </b-form-group>
              <b-form-group label="City" label-for="ship_sal_city">
                <b-form-input
                  type="text"
                  size="sm"
                  name="Shipping city"
                  v-model.trim="field.ship_sal_city"
                  v-validate="'max:200'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Shipping city')"
                >{{ errors.first('Shipping city') }}</p>
              </b-form-group>
              <b-form-group label="Country" label-for="ship_sal_country">
                <v-select
                  :clearable="false"
                  name="Shipping country"
                  id="search-select"
                  v-model.trim="field.ship_sal_country"
                  size="sm"
                  index="country_id"
                  label="country_name"
                  :options="$AppDetails.country_list"
                />
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Shipping country')"
                >{{ errors.first('Shipping country') }}</p>
              </b-form-group>
              <b-form-group label="Pincode" style="width:150px" label-for="ship_sal_pincode">
                <b-form-input
                  type="text"
                  size="sm"
                  name="Shipping pincode"
                  v-model.trim="field.ship_sal_pincode"
                  v-validate="'max:10'"
                ></b-form-input>
                <p
                  class="fw-semi-bold text-danger"
                  v-if="errors.has('Shipping pincode')"
                >{{ errors.first('Shipping pincode') }}</p>
              </b-form-group>
            </b-form>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <b-row class="pl-3 pt-3 pr-2" v-if="is_used >0">
      <b-col class="mx-3">
        <input
          type="checkbox"
          :true-value="1"
          :false-value="0"
          v-model="is_update_tns"
          id="is_update"
        />
        Update address in this contact as well as in all the previous transactions like draft invoices, quotation, and creditnotes.
      </b-col>
    </b-row>
    <div class="mt-3">
      <b-button size="sm" variant="primary" @click="onSubmit()" class="float-right mr-4">Save</b-button>
      <b-button
        size="sm"
        @click="toggleCustomerAddressDetails()"
        variant="light"
        class="float-right mr-3"
      >Cancel</b-button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"; // get data set in the state in vuex
import vSelect from "vue-select"; // vue seatch select component
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
export default {
  props: ["field", "address", "is_used"],
  data() {
    return {
      show_customer_address_details: false,
      is_update_tns: 0
    };
  },
  components: {
    vSelect
  },
  methods: {
    changeshipaddress(index) {
      this.field.ship_sal_addr_line_1 = this.address[index].addr_line_1;
      this.field.ship_sal_addr_line_2 = this.address[index].addr_line_2;
      this.field.ship_sal_state = this.address[index].state;
      this.field.ship_sal_city = this.address[index].city;
      this.field.ship_sal_country = this.address[index].country;
      this.field.ship_sal_pincode = this.address[index].pincode;
      // this.field.cus_ship_addr_id = this.address[index].cus_addr_id;
    },

    changebilladdress(index) {
      this.field.bill_sal_addr_line_1 = this.address[index].addr_line_1;
      this.field.bill_sal_addr_line_2 = this.address[index].addr_line_2;
      this.field.bill_sal_state = this.address[index].state;
      this.field.bill_sal_city = this.address[index].city;
      this.field.bill_sal_country = this.address[index].country;
      this.field.bill_sal_pincode = this.address[index].pincode;
      // this.field.cus_bill_addr_id = this.address[index].cus_addr_id;
    },
    copyAddress() {
      this.field.ship_sal_addr_line_1 = this.field.bill_sal_addr_line_1;
      this.field.ship_sal_addr_line_2 = this.field.bill_sal_addr_line_2;
      this.field.ship_sal_state = this.field.bill_sal_state;
      this.field.ship_sal_city = this.field.bill_sal_city;
      this.field.ship_sal_pincode = this.field.bill_sal_pincode;
      this.field.ship_sal_country = this.field.bill_sal_country;
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let data = JSON.stringify({
            field: this.field,
            is_update_tns: this.is_update_tns,
            type: "transaction"
          });
          this.submitted = true;
          this.$store.dispatch("customer/addresscreate", data).then(() => {
            var message, type;
            if (this.status_code == 200) {
              message = this.message;
              type = "success";

              this.submitted = false;
              this.$emit("setcustomerAddress", this.field);
              this.show_customer_address_details = !this
                .show_customer_address_details;
            } else {
              message = this.message;
              type = "danger";
            }

            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: message,
              type: type,
              showCloseButton: true
            });
          });
        }
      });
    },
    toggleCustomerAddressDetails() {
      this.show_customer_address_details = !this.show_customer_address_details;
      this.is_update_tns = 0;
    }
  },
  mounted() {
    EventBus.$on(
      "toggleCustomerAddressDetails",
      this.toggleCustomerAddressDetails
    ); // to trigger the method from parentcomponent
  },
  computed: {
    ...mapState({
      CustomerDetails: state => state.customer.listView,
      code: state => state.customer.code,
      message: state => state.customer.message,
      status_code: (state) => state.customer.status_code,
      status_message: (state) => state.customer.status_message,
      status_type: (state) => state.customer.status_type,
    })
  }
};
</script>